import type { IProgressPromise, IProgressPromiseGenerator } from '@monofe/util';
import type { IWorkspaceDB } from '../../../db/interface/db';
import type { INSTANTIATOR_INTERFACES } from '../../../model/interface';
import type { SourceApiDataArray, SourceApiRecord } from './interfaces';

function _addItems<Interface extends keyof INSTANTIATOR_INTERFACES>(
    database: IWorkspaceDB,
    entityName: Interface,
    items: SourceApiDataArray<Interface>,
): Promise<void> {
    const promise = entityName
        ? database.table(entityName).bulkAddOrUpdate(items)
        : Promise.reject(new Error(`Unable to find table name for unnamed entity`));

    return promise;
}

function update(
    promiser: IProgressPromiseGenerator,
    database: IWorkspaceDB,
    source: Partial<SourceApiRecord>,
): IProgressPromise<void> {
    return promiser.async(async progressCallback => {
        const shouldOpenClose = !database.isOpen();

        if (shouldOpenClose) {
            await database.open();
        }

        const patchPaths = Object.keys(source) as (keyof INSTANTIATOR_INTERFACES)[];
        const progressPerPath = 1 / patchPaths.length;

        for (const [index, patchPath] of patchPaths.entries()) {
            const items = source[patchPath];

            if (!items) {
                continue; /* No data */
            }

            const promise = _addItems(database, patchPath, items);

            await promise;

            progressCallback(index * progressPerPath);
        }

        if (shouldOpenClose) {
            database.close();
        }
    });
}

export default update;
